// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.speaker-card {
  display: flex;
  border-radius: var(--default-border-radius);
}
.speaker-card__avatar-wrapper {
  min-width: 90px;
  width: 30%;
  max-width: 135px;
  margin-right: 30px;
}
.speaker-card__content-wrapper {
  flex: 1;
}
.speaker-card__avatar {
  width: 100%;
  padding-top: 100%;
  border-radius: 100%;
  display: block;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
.speaker-card__name {
  margin-top: 0;
  margin-bottom: 0.75rem;
}
.speaker-card__role {
  display: flex;
}
.speaker-card__description {
  display: flex;
  text-align: var(--speaker-description-text-align);
  flex-direction: column;
}
@media (max-width: 768px) {
  .speaker-card__description {
    display: inline-block;
  }
}
.speaker-card__toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 0.75rem;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  font-size: 0.725rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--speaker-explode-icon-color);
}
.speaker-card__toggle-icon {
  font-size: 0.7rem;
  transition: transform 0.2s ease;
  transform: rotate(90deg);
}
.speaker-card__toggle-icon--expanded {
  transform: rotate(-90deg);
}
.speaker-card .ant-collapse .ant-collapse-header {
  display: none;
}
.speaker-card .ant-collapse .ant-collapse-content-box {
  padding: 15px 0 0;
}
.speaker-card {
  /** variables */
}
.speaker-card__avatar {
  border: 1px solid var(--speaker-picture-border-color);
}
.speaker-card__avatar.is-hidden {
  visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/SpeakerCard/SpeakerCard.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,2CAAA;AACJ;AACI;EACI,eAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AACR;AAEI;EACI,OAAA;AAAR;AAGI;EACI,WAAA;EACA,iBAAA;EAEA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,4BAAA;EACA,sBAAA;AAFR;AAKI;EACI,aAAA;EACA,sBAAA;AAHR;AAMI;EACI,aAAA;AAJR;AAOI;EACI,aAAA;EACA,iDAAA;EACA,sBAAA;AALR;AAOQ;EALJ;IAMQ,qBAAA;EAJV;AACF;AAOI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wCAAA;AALR;AAQI;EACI,iBAAA;EACA,+BAAA;EACA,wBAAA;AANR;AAQQ;EACI,yBAAA;AANZ;AAUI;EACI,aAAA;AARR;AAWI;EACI,iBAAA;AATR;AAnEA;EA+EI,eAAA;AATJ;AAUI;EACI,qDAAA;AARR;AAUQ;EACI,kBAAA;AARZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
